import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';
import { StyledLogoBar } from '../../TrustLogoBar/styles';
import { StyledVideoEmbed } from '../../VideoEmbed/styles';

import dynamicEmailTemplatesDotsSvg from '../../../assets/images/solutions/dynamic-email-templates-dots.svg';
import dynamicEmailTemplatesPlantSvg from '../../../assets/images/solutions/dynamic-email-templates-plant.svg';
import emailMarketingAutomationCoffee from '../../../assets/images/solutions/email-marketing-automation-coffee.svg';
import emailMarketingAutomationSprinkles from '../../../assets/images/solutions/email-marketing-automation-sprinkles.svg';
import emailDesignDots1 from '../../../assets/images/solutions/email-design-dots-1.svg';
import emailDesignDots2 from '../../../assets/images/solutions/email-design-dots-2.svg';
import socialDisplayAdsPlant1 from '../../../assets/images/solutions/social-display-ads-plant-1.svg';
import socialDisplayAdsPlant2 from '../../../assets/images/solutions/social-display-ads-plant-2.svg';
import emailMarketingCampaignsSvg from '../../../assets/images/solutions/email-marketing-campaigns.svg';
import signupFormsSvg from '../../../assets/images/solutions/signup-forms.svg';
import emailListManagementTrophySvg from '../../../assets/images/solutions/email-list-management-trophy.svg';

export const StyledCallout = styled.div`
  .text-callout {
    text-transform: uppercase;

    p {
      ${themeGet('font.whitneyMedium')}
      letter-spacing: 2px;
      margin-bottom: ${themeGet('scale.scaleDown03')};
      font-size: ${themeGet('scale.scaleDown01')};
    }

    h2 {
      font-size: ${themeGet('scale.scaleUp07')};
    }
  }
`;

export const StyledHero = styled.header`
  padding-top: ${themeGet('scale.scaleUp02')};
  padding-bottom: ${themeGet('scale.scaleUp05')};
  text-align: center;
  overflow: hidden;

  &.dynamic-email-templates,
  &.darkest-blue {
    background: linear-gradient(
        172deg,
        transparent 59.9%,
        ${themeGet('color.colorBlueDarkest')} 60%
      ),
      linear-gradient(
        180deg,
        ${themeGet('color.colorWhite')} 0%,
        ${themeGet('color.colorGrayBlue10')} 60%
      );
  }

  &.email-marketing-automation,
  &.purple {
    background: linear-gradient(
        172deg,
        transparent 59.9%,
        ${themeGet('color.colorPurple')} 60%
      ),
      linear-gradient(
        180deg,
        ${themeGet('color.colorWhite')} 0%,
        ${themeGet('color.colorGrayBlue10')} 60%
      );
  }

  &.dark-pink {
    background: linear-gradient(
        172deg,
        transparent 59.9%,
        ${themeGet('color.colorPinkDark')} 60%
      ),
      linear-gradient(
        180deg,
        ${themeGet('color.colorWhite')} 0%,
        ${themeGet('color.colorGrayBlue10')} 60%
      );
  }

  &.signup-forms,
  &.orange {
    background: linear-gradient(
        172deg,
        transparent 59.9%,
        ${themeGet('color.colorOrange')} 60%
      ),
      linear-gradient(
        180deg,
        ${themeGet('color.colorWhite')} 0%,
        ${themeGet('color.colorGrayBlue10')} 60%
      );

    ${StyledCallout},
    ${StyledLogoBar} {
      color: ${themeGet('color.colorOrangeDarkest')};
    }

    ${StyledLogoBar} path {
      fill: ${themeGet('color.colorOrangeDarkest')};
    }
  }

  &.yellow {
    background: linear-gradient(
        172deg,
        transparent 59.9%,
        ${themeGet('color.colorYellow')} 60%
      ),
      linear-gradient(
        180deg,
        ${themeGet('color.colorWhite')} 0%,
        ${themeGet('color.colorGrayBlue10')} 60%
      );
  }

  &.email-design,
  &.teal {
    background: linear-gradient(
        172deg,
        transparent 59.9%,
        ${themeGet('color.colorTeal')} 60%
      ),
      linear-gradient(
        180deg,
        ${themeGet('color.colorWhite')} 0%,
        ${themeGet('color.colorGrayBlue10')} 60%
      );

    ${StyledCallout},
    ${StyledLogoBar} {
      color: ${themeGet('color.colorTeal90')};
    }

    ${StyledLogoBar} path {
      fill: ${themeGet('color.colorTeal90')};
    }
  }

  &.green {
    background: linear-gradient(
        172deg,
        transparent 59.9%,
        ${themeGet('color.colorGreen40')} 60%
      ),
      linear-gradient(
        180deg,
        ${themeGet('color.colorWhite')} 0%,
        ${themeGet('color.colorGrayBlue10')} 60%
      );

    ${StyledCallout},
    ${StyledLogoBar} {
      color: ${themeGet('color.colorGreen90')};
    }

    ${StyledLogoBar} path {
      fill: ${themeGet('color.colorGreen90')};
    }
  }

  &.email-list-management,
  &.turquoise {
    background: linear-gradient(
        172deg,
        transparent 59.9%,
        ${themeGet('color.colorTurquoise')} 60%
      ),
      linear-gradient(
        180deg,
        ${themeGet('color.colorWhite')} 0%,
        ${themeGet('color.colorGrayBlue10')} 60%
      );

    ${StyledCallout},
    ${StyledLogoBar} {
      color: ${themeGet('color.colorTurquoiseDarkest')};
    }

    ${StyledLogoBar} path {
      fill: ${themeGet('color.colorTurquoiseDarkest')};
    }
  }

  &.social-and-display-ads,
  &.violet {
    background: linear-gradient(172deg, transparent 59.9%, #a000bd 60%),
      linear-gradient(
        180deg,
        ${themeGet('color.colorWhite')} 0%,
        ${themeGet('color.colorGrayBlue10')} 60%
      );
  }

  &.gray {
    background: linear-gradient(
      172deg,
      transparent 60%,
      ${themeGet('color.colorGrayBlue20')} 60%,
      ${themeGet('color.colorWhite')} 80%
    );
  }

  &.email-marketing-campaigns,
  &.white {
    background: linear-gradient(
        180deg,
        transparent 80%,
        #fdfeff 80%,
        ${themeGet('color.colorBlue10')} 100%
      ),
      linear-gradient(172deg, transparent 60%, #fdfeff 60%),
      linear-gradient(180deg, #fdfeff 0%, #f9fafe 40%, #f4f8ff 80%);
  }

  &.darkest-blue,
  &.purple,
  &.dark-pink,
  &.dynamic-email-templates,
  &.email-marketing-automation,
  &.social-and-display-ads {
    ${StyledCallout},
    ${StyledLogoBar} {
      color: ${themeGet('color.colorWhite')};
    }

    ${StyledLogoBar} path {
      fill: ${themeGet('color.colorWhite')};
    }
  }

  > .row {
    padding: 0 ${themeGet('scale.scaleBase')};
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    padding-bottom: ${themeGet('scale.scaleUp08')};

    > .row {
      padding: 0 ${themeGet('scale.scaleUp05')};
    }
  }
`;

export const StyledTitle = styled.div`
  h1 {
    margin: ${themeGet('scale.scaleUp07')} 0 ${themeGet('scale.scaleBase')};
    padding: 0 ${themeGet('scale.scaleBase')};
  }

  p {
    font-size: ${themeGet('scale.scaleBase')};
    padding: 0 ${themeGet('scale.scaleUp08')};
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    h1 {
      padding: 0;
      font-size: ${themeGet('scale.scaleUp07')};
    }

    p {
      padding: 0;
      font-size: ${themeGet('scale.scaleUp02')};
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    h1 {
      font-size: ${themeGet('scale.scaleUp08')};
    }
  }
`;

export const StyledCta = styled.div`
  p {
    ${themeGet('font.whitneyMedium')}
    font-size: ${themeGet('scale.scaleDown01')};
  }

  ul {
    margin-bottom: ${themeGet('scale.scaleUp03')};
    display: flex;
    justify-content: center;
    
    @media (max-width: ${themeGet('breakpoint.breakpointMobile')}) {
      flex-direction: column;
      
      > li + li {
        margin-top: ${themeGet('scale.scaleDown02')};
      }
    }
  }

  .btn {
    width: auto;
    margin: 0 ${themeGet('scale.scaleDown02')};
  }
`;

export const StyledVideo = styled.figure`
  max-width: 598px;
  margin: ${themeGet('scale.scaleUp07')} auto ${themeGet('scale.scaleUp09')};
  position: relative;

  ${StyledVideoEmbed} {
    border-radius: ${themeGet('border.borderRadius')};
    overflow: hidden;
    box-shadow: 0 0 1px 0 rgba(68, 95, 140, 0.45),
      0 10px 29px -8px rgba(44, 74, 125, 0.34);
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    ::before,
    ::after {
      content: '';
      display: block;
      position: absolute;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      pointer-events: none;
    }

    .email-list-management & {
      ::after {
        background-image: url(${emailListManagementTrophySvg});
        width: 167px;
        height: 354px;
        right: -192px;
        bottom: -5px;
      }
    }

    .dynamic-email-templates & {
      ::before {
        background-image: url(${dynamicEmailTemplatesDotsSvg});
        width: 247px;
        height: 288px;
        left: -136px;
        top: -71px;
      }
      ::after {
        background-image: url(${dynamicEmailTemplatesPlantSvg});
        width: 103px;
        height: 145px;
        right: -61px;
        bottom: -8px;
        z-index: ${themeGet('zIndex.zIndex01')};
      }
    }

    .email-marketing-automation & {
      ::before {
        background-image: url(${emailMarketingAutomationSprinkles});
        width: 205px;
        height: 197px;
        left: -87px;
        top: -48px;
      }
      ::after {
        background-image: url(${emailMarketingAutomationCoffee});
        width: 288px;
        height: 233px;
        right: -300px;
        bottom: 8px;
      }
    }

    .email-design & {
      ::before {
        background-image: url(${emailDesignDots1});
        width: 247px;
        height: 288px;
        left: -143px;
        top: -88px;
      }
      ::after {
        background-image: url(${emailDesignDots2});
        width: 146px;
        height: 170px;
        right: -73px;
        bottom: -22px;
      }
      ${StyledVideoEmbed} {
        position: relative;
        z-index: ${themeGet('zIndex.zIndex01')};
      }
    }

    .social-and-display-ads & {
      ::before {
        background-image: url(${socialDisplayAdsPlant1});
        width: 119px;
        height: 257px;
        z-index: ${themeGet('zIndex.zIndex01')};
        left: -107px;
        bottom: -20px;
      }
      ::after {
        background-image: url(${socialDisplayAdsPlant2});
        width: 144px;
        height: 182px;
        z-index: ${themeGet('zIndex.zIndex01')};
        right: -90px;
        bottom: -20px;
      }
    }

    .email-marketing-campaigns & {
      margin-bottom: calc(100px + ${themeGet('scale.scaleUp09')});

      ::after {
        background-image: url(${emailMarketingCampaignsSvg});
        width: 296px;
        height: 199px;
        right: -280px;
        bottom: -100px;
      }
    }
  }
`;

export const StyledImage = styled.figure`
  margin: ${themeGet('scale.scaleBase')} auto ${themeGet('scale.scaleUp05')};
  width: ${(props) => props.width}px;
  max-width: 100%;
  position: relative;

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    margin-bottom: ${themeGet('scale.scaleUp07')};
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    margin-bottom: ${themeGet('scale.scaleUp09')};

    .signup-forms & {
      ::after {
        content: '';
        display: block;
        background-image: url(${signupFormsSvg});
        width: 171px;
        height: 326px;
        position: absolute;
        right: -171px;
        bottom: 0;
      }
    }
  }
`;

export const StyledAdsCallout = styled.div`
  p {
    ${themeGet('font.whitneyMedium')}
    font-size: ${themeGet('scale.scaleDown01')};
    letter-spacing: 2px;
    color: ${themeGet('color.colorWhite')};
    margin-bottom: ${themeGet('scale.scaleUp03')};
  }

  ul {
    display: grid;
    grid-template-columns: repeat(3, auto);
    grid-column-gap: ${themeGet('scale.scaleUp07')};
    justify-content: center;
  }

  svg {
    max-width: 100%;
  }
`;
